import React, { useState } from "react";
import {
  Box,
  Drawer,
  Button,
  Typography,
  CircularProgress,
  TextField,
  Grid,
  FormControl,
} from "@mui/material";
import PinInput from "react-pin-input";

import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";

const ApproveFlowModal = ({ row, refresh }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [step, setStep] = useState(1); // 🔥 STEP CONTROL

  const [checkData, setCheckData] = useState(null);
  const [txnData, setTxnData] = useState(null);

  const [mpin, setMpin] = useState("");
  const [remarkVal, setRemarkVal] = useState("");
  const [amount, setAmount] = useState(row?.amount);

  const handleOpen = () => {
    setOpen(true);
    callCheckAPI();
  };

  const handleClose = () => {
    setOpen(false);
    setStep(1); // reset
  };

  // ✅ STEP 1: CHECK API
  const callCheckAPI = () => {
    setLoading(true);

    postJsonData(
      ApiEndpoints.CHECK_BANK_REQUEST,
      { id: row.id },
      setLoading,
      (res) => {
        const bankTxn = res?.data?.bank_transactions?.[0];

        if (!bankTxn) {
          // 🔥 No data → directly go to approve step
          setStep(2);
        } else {
          setCheckData(bankTxn);
          setTxnData(res?.data?.credit_request);
          setStep(1);
        }
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };

  // ✅ STEP 2: ADD ACCOUNT TXN
  const handleProceed = () => {
    setLoading(true);

    const data = {
      id: row.id,
      bank_name: checkData?.mop,
      bank_txn_id: checkData?.id,
      particulars: checkData?.description,
      remark: checkData?.remarks,
      given: checkData?.debit || 0,
      taken: checkData?.credit || 0,
      user_id: txnData?.username,
    };

    postJsonData(
      ApiEndpoints.ADD_ACCOUNT_TXN,
      data,
      setLoading,
      (res) => {
        okSuccessToast(res?.message);
        setStep(2); // 🔥 move to approve form
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };

  // ✅ FINAL APPROVE
  const handleApprove = (e) => {
    e.preventDefault();

    const data = {
      id: row.id,
      amount: amount,
      remark: remarkVal,
      action: "APPROVE",
      // mpin: mpin,
    };

    setLoading(true);

    postJsonData(
      ApiEndpoints.CRED_REQ_APPROVE,
      data,
      setLoading,
      (res) => {
        okSuccessToast("Request Approved Successfully");
        handleClose();
        if (refresh) refresh();
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };

  return (
    <>
      {/* 🔘 Approve Button */}
      <Button onClick={handleOpen} variant="contained" color="success">
        Approve
      </Button>

      <Drawer anchor="right" open={open} onClose={handleClose}>
        <Box sx={{ width: 400, p: 2 }}>
          <Typography variant="h6">
            {step === 1 ? "Check Bank Request" : "Approve Request"}
          </Typography>

          {loading ? (
            <CircularProgress />
          ) : (
            <>
              {/* 🔥 STEP 1 UI */}
              {step === 1 && (
                <>
                  <Box sx={{ mt: 2 }}>
                    <Typography>
                      Description: {checkData?.description || "NA"}
                    </Typography>
                    <Typography>Mode: {checkData?.mop || "NA"}</Typography>
                    <Typography>
                      Remarks: {checkData?.remarks || "NA"}
                    </Typography>
                    <Typography>Credit: {checkData?.credit || 0}</Typography>
                    <Typography>Debit: {checkData?.debit || 0}</Typography>
                  </Box>

                  <Button
                    variant="contained"
                    sx={{ mt: 3 }}
                    onClick={handleProceed}
                  >
                    Confirm & Proceed
                  </Button>
                </>
              )}

              {/* 🔥 STEP 2 UI (Approve Form) */}
              {step === 2 && (
                <Box component="form" onSubmit={handleApprove} sx={{ mt: 2 }}>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <TextField
                      label="Amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      required
                      disabled
                    />
                  </FormControl>

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <TextField
                      label="Remarks"
                      onChange={(e) => setRemarkVal(e.target.value)}
                      required
                    />
                  </FormControl>

                  {/* <Box sx={{ textAlign: "center", mb: 2 }}>
                    <Typography>M-PIN</Typography>
                    <PinInput
                      length={6}
                      type="password"
                      onChange={(val) => setMpin(val)}
                      inputStyle={{
                        width: "40px",
                        height: "40px",
                        borderBottom: "1px solid #000",
                      }}
                    />
                  </Box> */}

                  <Button type="submit" variant="contained" fullWidth>
                    Final Approve
                  </Button>
                </Box>
              )}
            </>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default ApproveFlowModal;
